import React, { useState } from "react";

export const ToasterContext = React.createContext();

export const ToasterProvider = ({ children }) => {
  const [state, setState] = useState({
    show: false,
    message: "",
    title: "",
    /*
     * 0 - none
     * 1 - info
     * 2 - warn
     * 3 - error
     * 4 - success
     * */
    type: 0,
  });

  return (
    <ToasterContext.Provider value={{ state, setState }}>
      {children}
    </ToasterContext.Provider>
  );
};
